import React from "react";
import { getPathByRoute } from 'App.js';
import routeKeys from 'CustomerRouteKeys.js';
import { StepContextProvider, useStepContext, StepContext } from 'context/StepContext.js';

import TakeOverLayout from 'layouts/TakeOverLayout.js';
import BlockOrReplaceSelect from 'pages/account/card/BlockOrReplaceSelect.js';
import OptionsSelectedProvider from 'pages/account/card/replacement/OptionsSelectedProvider.js';
import PurchaseReplacementCharlieCardCcForm from 'pages/account/PurchaseReplacementCharlieCardCcForm.js';
import { ReplacementContextProvider } from 'context/ReplacementContext.js';
import CmsContentRendered from "components/data/CmsContentRendered";
import FundingSourcesProvider from "context/FundingSourcesContext.js";
import ReplacementSelect from "components/suspend-replace/ReplacementSelect.js";
import { findPrimaryToken } from "components/manage-cards/TokenHelpers";
import { OPEN_TRANSIT_RESTRICTED_CARD, OPEN_TRANSIT_TEMPORARY_CARD } from "server/api-types/WSSubsystemAccountToken";
import { useTransitAccount } from "components/data/transit-account/TransitAccount";
import { ComponentLoading } from "components/icons/LoadingIcon";

const cms = {
	header: 'miscText.card-freeze-header',
	blockHeader: 'miscText.card-freeze-header-block',
};

export const BLOCK_OR_REPLACE_CARD = 0;
export const PURCHASE_REPLACEMENT = 1;
export const TRANSFER_REPLACEMENT = 2;
export const BYPASS_TO_REPLACEMENT = 3;

const CurrentStep = () => {
	const { step } = useStepContext();

	switch (step) {
		case BLOCK_OR_REPLACE_CARD:
			return <BlockOrReplaceSelect />;
		case PURCHASE_REPLACEMENT:
			return <PurchaseReplacementCharlieCardCcForm />;
		case TRANSFER_REPLACEMENT:
			return <ReplacementSelect />;
	}
};

const BlockOrReplaceFlow = () => {
	const {
		data: transitAccountQdata,
		loading,
	} = useTransitAccount();

	if (loading) {
		return <ComponentLoading />;
	}

	const { tokens, subsystemAccountReference } = transitAccountQdata?.transitAccountQ ?? {};
	const primaryToken = findPrimaryToken(tokens);

	const isTempCard = primaryToken.mediaType === OPEN_TRANSIT_TEMPORARY_CARD;
	const isHandsFreeCard = primaryToken.mediaType === OPEN_TRANSIT_RESTRICTED_CARD;

	const canBlockOnly = isHandsFreeCard || isTempCard;


	return <FundingSourcesProvider>
		<ReplacementContextProvider>

			<OptionsSelectedProvider>
				<StepContextProvider min={BLOCK_OR_REPLACE_CARD} max={TRANSFER_REPLACEMENT}>
					<StepContext.Consumer>{({ step }) =>
						<TakeOverLayout
							title={<CmsContentRendered contentKey={canBlockOnly ? cms.blockHeader : cms.header} fallbackValue={canBlockOnly ? "Block Card" :"Block or Replace Card"} />}
							showTabs={false}
							showCancel
							skip={step === PURCHASE_REPLACEMENT}
							cancelLink={getPathByRoute(routeKeys.AccountCardSettings, { transit_account_id: subsystemAccountReference })}
							showNickname
						>
							<CurrentStep />
						</TakeOverLayout>
					}</StepContext.Consumer>
				</StepContextProvider>
			</OptionsSelectedProvider>

		</ReplacementContextProvider>
	</FundingSourcesProvider>;
};

export default BlockOrReplaceFlow;
